module.exports = __webpack_public_path__ + "static/media/1350_Cart_Medical_editHL.d9596fd3.png";